<template>
  <v-dialog
      v-model="dialogVisible"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
      class="d-flex flex-column"
  >
    <v-card tile class="d-flex flex-column" style="height: 100vh;">
      <div id="titulo-dialog" class="df pa-4 d-flex align-center" style="flex-shrink: 0; position: relative; z-index: 5; background: #071a2a;">
        <v-btn icon dark @click="close()" class="me-4">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <img :src="logo" alt="webcotacao" class="h-35px">
      </div>

      <!-- Breadcrumbs -->
      <app-breadcrumbs :items="breadcrumbItems" />

      <!-- Title Row + Actions + Progress -->
      <div class="px-6 py-4" style="flex-shrink: 0; background: white; position: relative; z-index: 3; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);">
        <div class="d-flex align-center justify-space-between mb-4">
          <div class="d-flex align-center">
            <v-btn icon @click="close()" class="mr-2">
              <v-icon color="grey darken-2">mdi-arrow-left</v-icon>
            </v-btn>

            <h2 class="font-weight-bold mr-3 text-h6 d-flex align-center">
              Cotação {{ idCotacao ? `[${idCotacao}]` : '' }}

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-on="on" v-bind="attrs" style="cursor: help">
                    <v-icon small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon>
                  </div>
                </template>
                <span>Gerado automaticamente. Pode ser usado em buscas internas.</span>
              </v-tooltip>
            </h2>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div v-on="on" v-bind="attrs">
                  <app-badge :color="getStatusColor((cotacao && cotacao.nome_status) || 'Rascunho')">
                    <span :class="getStatusIcon((cotacao && cotacao.nome_status) || 'Rascunho')" class="mr-1 text-sm-body-1"></span>
                    {{ (cotacao && cotacao.nome_status) || 'Rascunho' }}
                  </app-badge>
                </div>
              </template>
              <span>Estado atual da cotação. Rascunho: só você vê. Aberta: fornecedores podem enviar propostas. Fechada: prazo encerrado.</span>
            </v-tooltip>


          </div>

          <div class="d-flex align-center">
            <v-btn
                text
                color="error"
                class="text-capitalize mr-2"
                @click="descartarRascunho"
                :disabled="!idCotacao || (cotacao && cotacao.publicar_cotacao)"
            >
              Descartar rascunho
            </v-btn>

            <v-btn
                outlined
                color="primary"
                class="text-capitalize mr-2"
                :loading="isSavingRascunho"
                :disabled="isSavingRascunho || (cotacao && cotacao.publicar_cotacao)"
                @click="salvarRascunho"
            >
              Salvar rascunho
            </v-btn>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  class="text-capitalize"
                  elevation="0"
                  :loading="isPublicando"
                  :disabled="isPublicando || (cotacao && cotacao.publicar_cotacao) || completedCount < totalRequired"
                  @click="publicarCotacao"
                >
                  Abrir cotação e enviar convites
                </v-btn>
              </template>
              <span>
                Abre a cotação agora, envia e-mail/WhatsApp para os fornecedores convidados e habilita o envio de propostas até {{ dadosGerais.data_fim || '__/__/____' }} às {{ dadosGerais.hora_fim || '__:__' }}.
              </span>
            </v-tooltip>
          </div>
        </div>

        <!-- Barra de Progresso -->
        <div>
          <v-progress-linear
              :value="progressPercent"
              color="primary"
              height="4"
              style="width: 25%;"
              rounded
              class="mb-2"
          ></v-progress-linear>
          <span class="text-caption font-weight-medium grey--text text--darken-2">
            {{ completedCount }}/{{ totalRequired }} Itens obrigatórios preenchidos
          </span>
        </div>
      </div>

      <div v-if="!isLoading" ref="contentBodyRef" class="content-body flex-grow-1 overflow-y-auto">
        <Accordion type="multiple" :default-value='["item1", "item2", "item3", "item4"]'>
          <AccordionItem id="item1" v-slot="{ isOpen, toggle }">
            <AccordionTrigger :isOpen="isOpen" :toggle="toggle">
              <v-icon :color="isDadosGeraisComplete ? '#8bdfa0' : '#bdbdbd'">mdi-check-decagram</v-icon>
              Dados gerais <span style="color: #fbbd5a">*</span>
            </AccordionTrigger>
            <AccordionContent :isOpen="isOpen">

              <v-form>
                <div>
                  <p class="mb-3 font-weight-medium">Identificação <span style="color: #fbbd5a">*</span></p>
                  <div>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div v-on="on" v-bind="attrs">
                          <v-text-field
                            v-model="dadosGerais.titulo"
                            autofocus
                            label="Título *"
                            outlined
                            dense
                            :error-messages="validate.titulo"
                          ></v-text-field>
                        </div>
                      </template>
                      <span>Nome da cotação usado em buscas e comunicações. Gerado como ‘Cotação [ID] do dia [DD/MM/YYYY]’. Você pode editar.</span>
                    </v-tooltip>
                  </div>

                  <div>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div v-on="on" v-bind="attrs">
                          <v-select
                            v-model="dadosGerais.empresa"
                            :items="empresas"
                            small-chips
                            label="CNPJ/Empresa*"
                            outlined
                            dense
                            item-value="idfilial"
                            :item-text="item => `${formatCnpj(item.cnpj)} / ${item.razao_social || item.nome_fantasia}`"
                            :error-messages="validate.empresa"
                            :disabled="isEmpresaDisabled"
                            :menu-props="{ offsetY: true, maxHeight: 300 }"
                          ></v-select>
                        </div>
                      </template>
                      <span>Informe o CNPJ da sua empresa (quem está comprando) para contexto fiscal.</span>
                    </v-tooltip>
                  </div>

                  <p class="mb-3 font-weight-medium d-flex align-center">Período de recebimento de propostas <span style="color: #fbbd5a">*</span>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div v-on="on" v-bind="attrs" style="cursor: help">
                          <v-icon small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon>
                        </div>
                      </template>
                      <span>Janela em que fornecedores podem enviar propostas. Ao abrir a cotação, convites são enviados; respostas são aceitas até o término.</span>
                    </v-tooltip>
                  </p>

                  <div class="d-flex">
                    <div class="mx-2">
                      <p class="mb-3 font-weight-medium">Inicio</p>
                      <div class="d-flex">
                        <v-text-field
                            v-model="dadosGerais.data_inicio"
                            placeholder="01/01/1999"
                            append-icon="mdi-calendar-blank-outline"
                            v-mask="'##/##/####'"
                            outlined
                            dense
                            :error-messages="validate.data_inicio"
                        ></v-text-field>

                        <div class="divider"></div>

                        <v-text-field
                            v-model="dadosGerais.hora_inicio"
                            placeholder="10:00"
                            append-icon="mdi-clock-outline"
                            v-mask="'##:##'"
                            outlined
                            dense
                            :error-messages="validate.hora_inicio"
                        ></v-text-field>
                      </div>
                    </div>

                    <div class="divider"></div>

                    <div class="mx-2">
                      <p class="mb-3 font-weight-medium">Término</p>
                      <div class="d-flex">
                        <v-text-field
                            v-model="dadosGerais.data_fim"
                            placeholder="01/01/1999"
                            append-icon="mdi-calendar-blank-outline"
                            v-mask="'##/##/####'"
                            outlined
                            dense
                            :error-messages="validate.data_fim"
                        ></v-text-field>

                        <div class="divider"></div>

                        <v-text-field
                            v-model="dadosGerais.hora_fim"
                            placeholder="10:00"
                            append-icon="mdi-clock-outline"
                            v-mask="'##:##'"
                            outlined
                            dense
                            :error-messages="validate.hora_fim"
                        ></v-text-field>
                      </div>
                    </div>
                  </div>

                  <div class="wc-lembrete-box mb-4">
                    <div class="d-flex align-center">
                      <v-switch
                        v-model="dadosGerais.lembrete_diario"
                        color="primary"
                        hide-details
                        class="mt-0 pt-0"
                        inset
                      />
                      <span class="wc-lembrete-title ml-1">
                        Lembretes diários no fim do prazo
                        <template v-if="dadosGerais.lembrete_diario">
                          <span v-if="dadosGerais.lembrete_diario_dias === 0" class="grey--text text--darken-1">(desativados)</span>
                          <span v-else>({{ dadosGerais.lembrete_diario_dias || 'X' }} dias)</span>
                        </template>
                      </span>
                    </div>

                    <div v-if="dadosGerais.lembrete_diario" class="mt-3 ml-1">
                      <div class="d-flex align-center flex-wrap">
                        <span class="wc-lembrete-text mr-2" style="white-space: nowrap;">Enviar lembretes diários quando faltar</span>
                        <v-text-field
                          v-model.number="dadosGerais.lembrete_diario_dias"
                          type="number"
                          min="0"
                          max="30"
                          outlined
                          dense
                          hide-details
                          :error="!!validate.lembrete_diario_dias"
                          class="wc-lembrete-dias-input mx-2"
                        />
                        <span class="wc-lembrete-text ml-2" style="white-space: nowrap;"><b>dias</b> para encerrar.</span>
                      </div>

                      <p v-if="validate.lembrete_diario_dias" class="wc-lembrete-error mt-1 mb-0">
                        {{ validate.lembrete_diario_dias }}
                      </p>

                      <p v-if="dadosGerais.lembrete_diario_dias === 0 && !validate.lembrete_diario_dias" class="wc-lembrete-status mt-2 mb-0">
                        Lembretes: desativados
                      </p>

                      <p v-if="validate.lembrete_diario_warning" class="wc-lembrete-warning mt-2 mb-0">
                        {{ validate.lembrete_diario_warning }}
                      </p>

                      <p class="wc-lembrete-helper mt-2 mb-0">
                        O sistema enviará lembretes diários apenas para fornecedores que ainda não enviaram proposta. Quando o fornecedor enviar ou quando a cotação encerrar, os lembretes param
                      </p>
                    </div>
                  </div>

                  <p class="mb-3 font-weight-medium">Equipe</p>

                  <p class="mb-3 font-weight-medium ml-3">Responsável <span style="color: #fbbd5a">*</span></p>
                  <div class="ml-3">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div v-on="on" v-bind="attrs">
                          <v-autocomplete
                            v-model="dadosGerais.responsavel"
                            :items="usuarios"
                            small-chips
                            label="Responsável*"
                            outlined
                            dense
                            item-value="id"
                            item-text="name"
                            :search-input.sync="responsavelSearch"
                            placeholder="Pesquisar responsável"
                            prepend-inner-icon="mdi-magnify"
                            :menu-props="{ offsetY: true, maxHeight: 300 }"
                            hide-no-data
                            hide-selected
                            :error-messages="validate.responsavel"
                          ></v-autocomplete>
                        </div>
                      </template>
                      <span>Dono da cotação. Recebe todas as notificações e é o ponto de contato interno. Pode ser alterado.</span>
                    </v-tooltip>
                  </div>

                  <div class="ml-3">
                    <div class="my-2 d-flex">
                      <div class="d-flex flex-row align-items-center px-4 py-2 font-weight-medium content-alert">
                        <span style="color: #0CB935">{{ (dadosGerais.seguidores && dadosGerais.seguidores.length) || 0 }}</span>
                        <p style="margin: 0 6px">seguidores adicionados</p>
                      </div>

                      <div>
                        <v-btn
                            class="mx-2 wc-btn-actions"
                            color="primary"
                            outlined
                            @click="visualizarSeguidores"
                        >
                          Visualizar seguidores
                          <v-icon class="ml-5px">mdi-eye-outline</v-icon>
                        </v-btn>
                      </div>

                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <div v-on="on" v-bind="attrs" style="cursor: help">
                            <v-icon small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon>
                          </div>
                        </template>
                        <span>
                          Os seguidores não realizam operações na cotação,
                          eles somente visualizam e acompanham a evolução da cotação.
                        </span>
                      </v-tooltip>
                    </div>

                  </div>
                </div>
              </v-form>

            </AccordionContent>
          </AccordionItem>

          <AccordionItem id="item2" v-slot="{ isOpen, toggle }">
            <AccordionTrigger :isOpen="isOpen" :toggle="toggle">
              <div class="d-flex align-center">
                <v-icon :style="{ color: isLocaisRecebimentoComplete ? '#8bdfa0' : '#bdbdbd' }" class="mr-1">mdi-check-decagram</v-icon>
                Locais de recebimento <span style="color: #fbbd5a">*</span>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-on="on" v-bind="attrs" style="cursor: help">
                      <v-icon small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon>
                    </div>
                  </template>
                  <span>
                  Endereços e janelas de entrega. Fornecedores consideram isso para frete e prazos.
                </span>
                </v-tooltip>
              </div>
            </AccordionTrigger>
            <AccordionContent :isOpen="isOpen">

              <!-- Componente extraído de Locais de Recebimento -->
              <NovaCotacaoLocaisRecebimento
                  :locais="locaisRecebimento"
                  :empresas="empresas"
                  :dialogState="openLocalRecebimento"
                  :handleCloseDialog="handleCloseLocalRecebimento"
                  :prazo-entrega-desejado-dias="dadosGerais.prazo_entrega_desejado_dias"
                  :prazo-error-messages="prazoEntregaErrorMessages"
                  @update:prazoEntregaDesejadoDias="onUpdatePrazoEntregaDesejadoDias"
                  @add="handleAddLocal"
                  @edit="handleEditLocal"
                  @delete="handleDeleteLocal"
                  @save="handleSaveLocal"
              />

            </AccordionContent>
          </AccordionItem>

          <AccordionItem id="item3" v-slot="{ isOpen, toggle }">
            <AccordionTrigger :isOpen="isOpen" :toggle="toggle">
              <div class="d-flex align-center">
                <v-icon :color="isProdutosComplete ? '#8bdfa0' : '#bdbdbd'" class="mr-1">mdi-check-decagram</v-icon>
                Produtos <span style="color: #fbbd5a">*</span>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-on="on" v-bind="attrs" style="cursor: help">
                      <v-icon small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon>
                    </div>
                  </template>
                  <span>
                  Itens que serão cotados. Cadastre/ajuste U.M., quantidades e tolerâncias em ‘Visualizar Produtos’.
                </span>
                </v-tooltip>
              </div>
            </AccordionTrigger>
            <AccordionContent :isOpen="isOpen">

              <ViewTotais
                :data="produtos"
                tipo="produtos"
                :total="200"
                @visualizar="handleVisualizar" />

            </AccordionContent>
          </AccordionItem>

          <AccordionItem id="item4" v-slot="{ isOpen, toggle }">
            <AccordionTrigger :isOpen="isOpen" :toggle="toggle">
              <div class="d-flex align-center">
                <v-icon v-if="hasFornecedoresSemContato" color="#fbbd5a" class="mr-1">mdi-alert-circle</v-icon>
                <v-icon v-else :color="isFornecedoresComplete ? '#8bdfa0' : '#bdbdbd'" class="mr-1">mdi-check-decagram</v-icon>
                Fornecedores <span style="color: #fbbd5a">*</span>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-on="on" v-bind="attrs" style="cursor: help">
                      <v-icon small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon>
                    </div>
                  </template>
                  <span>
                  Empresas convidadas. Adicione ao menos um contato por fornecedor.
                  Todos os contatos recebem convite e podem responder pela empresa (a proposta é única por fornecedor).
                </span>
                </v-tooltip>
              </div>
            </AccordionTrigger>
            <AccordionContent :isOpen="isOpen">

              <ViewTotais
                  :data="fornecedores"
                  tipo="fornecedores"
                  :total="200"
                  @visualizar="handleVisualizar"
              />

              <div v-if="hasFornecedoresSemContato" class="d-flex align-center mt-2 ml-4 mb-4">
                <v-icon color="#ff9800" size="16" class="mr-1">mdi-alert-circle-outline</v-icon>
                <span class="text-caption" style="color: #616161; font-size: 11px !important;">Alguns fornecedores não possuem contato vinculado.</span>
              </div>

            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </v-card>

    <VisualizarFornecedoresCotacaoDialog
        :visible="openVisualizarFornecedores"
        :id-cotacao="props.idCotacao"
        :handleClose="handleCloseVisualizarFornecedores"
        @update:fornecedores="setFornecedores"
    />

    <VisualizarProdutosCotacaoDialog
        :visible="openVisualizarProdutos"
        :id-cotacao="props.idCotacao"
        :handleClose="handleCloseVisualizarProdutos"
    />

    <SeguidoresDialog
        :visible="openSeguidoresDialog"
        :seguidores="usuarios"
        :seguidores-selecionados="dadosGerais.seguidores"
        :handleClose="handleCloseSeguidores"
        @save="handleSaveSeguidores"
    />

  </v-dialog>
</template>

<script setup>
import logo from "@/assets/logo_header.png";
import Accordion from "@/components/utils/ui_v4/accordion/Accordion.vue";
import AccordionContent from "@/components/utils/ui_v4/accordion/AccordionContent.vue";
import AccordionItem from "@/components/utils/ui_v4/accordion/AccordionItem.vue";
import AccordionTrigger from "@/components/utils/ui_v4/accordion/AccordionTrigger.vue";
import AppBadge from "@/components/utils/ui_v4/feedback/AppBadge.vue";
import AppBreadcrumbs from "@/components/utils/ui_v4/navigations/AppBreadcrumbs.vue";
import NovaCotacaoLocaisRecebimento from "@/components/webcotacao/components/NovaCotacaoLocaisRecebimento.vue";
import SeguidoresDialog from "@/components/webcotacao/components/SeguidoresDialog.vue";
import ViewTotais from "@/components/webcotacao/components/ViewTotais.vue";
import VisualizarFornecedoresCotacaoDialog from "@/components/webcotacao/components/VisualizarFornecedoresCotacaoDialog.vue";
import VisualizarProdutosCotacaoDialog from "@/components/webcotacao/components/VisualizarProdutosCotacaoDialog.vue";
import useNovaCotacaoDialog from "@/components/webcotacao/composables/useNovaCotacaoDialog";
import { computed, onBeforeUnmount, ref, watch } from "vue";

const contentBodyRef = ref(null);
let _scrollCleanup = null;
const responsavelSearch = ref("");

const closeOpenSelectMenus = () => {
  // Fecha o dropdown/menu aberto sem dar blur no input (evita "valor some e volta").
  const menuOpen = document.querySelector('.menuable__content__active');
  if (!menuOpen) return;

  const ev = new KeyboardEvent('keydown', {
    key: 'Escape',
    code: 'Escape',
    keyCode: 27,
    which: 27,
    bubbles: true,
  });

  const active = document.activeElement;
  if (active && typeof active.dispatchEvent === "function") active.dispatchEvent(ev);
  document.dispatchEvent(ev);
};

watch(contentBodyRef, (el) => {
  if (_scrollCleanup) {
    _scrollCleanup();
    _scrollCleanup = null;
  }
  if (el) {
    el.addEventListener('scroll', closeOpenSelectMenus, { passive: true });
    _scrollCleanup = () => el.removeEventListener('scroll', closeOpenSelectMenus);
  }
});

onBeforeUnmount(() => {
  if (_scrollCleanup) _scrollCleanup();
});

const props = defineProps({
  visible: { type: Boolean },
  idCotacao: { type: Number },
  handleClose: { type: Function },
});

const {
  isLoading,
  produtos,
  fornecedores,
  locaisRecebimento,
  empresas,
  usuarios,
  cotacao,
  dadosGerais,
  validate,
  isEmpresaDisabled,
  salvarRascunho,
  publicarCotacao,
  descartarRascunho,
  isSavingRascunho,
  isPublicando,
  setFornecedores,
  openLocalRecebimento,
  handleAddLocal,
  handleEditLocal,
  handleSaveLocal,
  handleDeleteLocal,
  handleCloseLocalRecebimento,
  openVisualizarFornecedores,
  openVisualizarProdutos,
  handleCloseVisualizarFornecedores,
  handleCloseVisualizarProdutos,
  handleVisualizar,
  isDadosGeraisComplete,
  isLocaisRecebimentoComplete,
  isProdutosComplete,
  isFornecedoresComplete,
  totalRequired,
  completedCount,
  progressPercent,
  visualizarSeguidores,
  openSeguidoresDialog,
  handleCloseSeguidores,
  handleSaveSeguidores,
  close,
  dialogVisible,
  getStatusColor,
  getStatusIcon,
  hasFornecedoresSemContato,
} = useNovaCotacaoDialog(props);

const onUpdatePrazoEntregaDesejadoDias = (v) => {
  dadosGerais.prazo_entrega_desejado_dias = v;
};

const prazoEntregaErrorMessages = computed(() => {
  const e = validate.prazo_entrega_desejado_dias;
  if (e === null || e === undefined || e === "") return [];
  return Array.isArray(e) ? e : [e];
});

const formatCnpj = (cnpj) => {
  if (!cnpj) return '';
  const cleaned = cnpj.replace(/\D/g, '');
  if (cleaned.length !== 14) return cnpj;
  return cleaned.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
      '$1.$2.$3/$4-$5'
  );
};

const breadcrumbItems = [
  { title: 'Carrinho de compras', onClick: () => {} },
  { title: 'Cotação', onClick: () => {} },
  { title: 'Nova cotação', active: true, badgeColor: 'blue' }
];

</script>

<style scoped>
.divider {
  height: 35px;
  width: 20px;
}

/* Padding lateral grande só no conteúdo que rola */
.content-body {
  padding: 2rem 10rem;
  background: #ffffff;
}

.empty-data {
  width: 100%;
  height: 30px;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.wc-lembrete-box {
  padding: 16px 0;
}

.wc-lembrete-title {
  font-weight: 600;
  font-size: 0.9rem;
  color: #333;
}

.wc-lembrete-text {
  font-size: 0.875rem;
  color: #444;
}

.wc-lembrete-helper {
  font-size: 0.78rem;
  color: #777;
  line-height: 1.4;
}

.wc-lembrete-error {
  font-size: 0.78rem;
  color: #ff5252;
  line-height: 1.3;
  margin-left: 2px;
}

.wc-lembrete-warning {
  font-size: 0.82rem;
  color: #e65100;
  line-height: 1.4;
}

.wc-lembrete-status {
  font-size: 0.82rem;
  color: #9e9e9e;
  font-style: italic;
}

.wc-lembrete-dias-input {
  max-width: 72px;
  flex-shrink: 0;
}

/* Remove setas do input de dias do lembrete */
.wc-lembrete-dias-input ::v-deep input[type="number"]::-webkit-outer-spin-button,
.wc-lembrete-dias-input ::v-deep input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.wc-lembrete-dias-input ::v-deep input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}
</style>
